import React from "react";
import "./setting-page.scss";
import { useEffect, useState } from "react";
import { Container, Row, Col, Tab, Nav, Breadcrumb } from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";
import "./setting-page.scss";
import TabGenral from "./General/TabGeneral";
import { useTranslation } from "react-i18next";
import WebServiceAmazon from "../../Services/WebServiceAmazon";
const Setting = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [brandDetails, setBrandDetails] = useState("");
  useEffect(() => {
    if (searchParams.get("id") ?? "") {
      getBrandSettings(searchParams.get("id") ?? "");
    } else {
      getBrandSettings(localStorage.getItem("app_id"));
    }
  }, []);

  const getBrandSettings = (id: any) => {
    return WebServiceAmazon.getAPI({
      action: `user/user-website/details?id=` + id,
      body: null,
    })
      .then((res: any) => {
        setBrandDetails(res.info);
      })
      .catch((error) => {
        return error;
      });
  };

  return (
    <>
      <div className="app-body setting-page">
        <section className="page-breadcums">
          <Container fluid>
            <div className="">
              <Row className="align-items-center">
                <Col md={6}>
                  <Breadcrumb>
                    <Breadcrumb.Item>
                      <Link to={"/campaign-tracker"}>{t("Common.Home")}</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                      {t("Common.Settings")}
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </Col>
                <Col md={6} className="text-end"></Col>
              </Row>
            </div>
          </Container>
        </section>
        <Container>
          <Row className="justify-content-center mt-5">
            <Col lg={7}>
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <div className="wmx-tab-style-1">
                  <Nav
                    variant="pills"
                    className=" justify-content-center border-0 p-0 bg-transparent"
                  >
                    <Nav.Item>
                      <Nav.Link eventKey="first">
                        {t("Common.General")}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <div>
                  <Tab.Content className="mt-3">
                    <Tab.Pane eventKey="first">
                      <TabGenral
                        data={brandDetails}
                        sendData={(data: any) => {
                          getBrandSettings(data);
                        }}
                      />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default Setting;
